import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { PowerBiReportData } from 'models/PowerBiReportData';

import { FunctionsHelper } from 'utils/FunctionsHelper';

import MainBackendAxios from '../utils/MainBackendAxios';

export const PowerBiReportService = {
  getFullDataForReport: async (body: {
    reportId: string;
    groupId: string;
  }): Promise<ApiResponse<PowerBiReportData | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/power-bi-report/get-full-data-for-report`,
        body
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
